import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

// Remove and replace with the data
const USER_TYPES = [
	"Super Admin", /* 1 */
	"Admin", /* 2 */
	"Eye Specialist", /* 3 */
	'Camera Man', /* 4 */
	"Data Entry", /* 5 */
	"Patient", /* 6 */
];

const store = new Vuex.Store({
	strict: process.env.NODE_ENV !== 'production',
	state: {
		loggedIn: false,
		isFooterHidden: false,
		user: false,
		arabic: false,
		userInfo: null,
		loading: false,
		notification: {},
		permissions: [],
	},
	mutations: {
		hideFooter(state, value) {
			state.isFooterHidden = value;
		},
		setArabic(state, value) {
			state.arabic = value;
		},
		updateUserInfo(state, value) {
			// TODO
			// REPLACE with mixin
			state.userInfo = value;

			if (value == null) {
				state.user = false;
				state.loggedIn = false;
			} else {
				state.user = USER_TYPES[value.UserType - 1];
				state.loggedIn = true;
			}
		},
		setLoading(state, value) {
			state.loading = value;
		},
		pushNotification(state, value) {
			state.notification = value;
		},
		setPermissions(state, value) {
			state.permissions = value;
		},
	},
	actions: {
		triggerHideFooter(state, value) {
			this.commit("hideFooter", value);
		},
		setArabic(state, value) {
			this.commit("setArabic", value);
		},
		setUserInfo(state, value) {
			this.commit("updateUserInfo", value);
		},
		triggerLoading(state, value) {
			this.commit("setLoading", value);
		},
		triggerPushNotification(state, value) {
			this.commit("pushNotification", value);
		},
		setPermissions(state, value) {
			this.commit("setPermissions", value);
		},
	}
})

export default store;